import CardRisk from "./CardRisk";
export default CardRisk;
